// Shared labels and formatting for the team's admin pages (English only: internal tool).
import axios from 'axios';
import { BACKEND_MAIN_URL } from '../config';
import authHeaders from '../authHeaders';

export const API = `${BACKEND_MAIN_URL}/api/admin`;
// Staging's database is a July 2026 copy of production plus test accounts: say so on the page.
export const isStaging = /staging/i.test(BACKEND_MAIN_URL);
export const PLANS = ['freemium', 'standard', 'premium', 'finance'];
// The relationship with the user, set by the team (usage is computed, never typed in).
export const STAGES = {
  new: 'New', contacted: 'Contacted', onboarding: 'Onboarding', engaged: 'Engaged',
  at_risk: 'At risk', churned: 'Churned', partner: 'Partner',
};
export const SEGMENTS = [
  ['', 'Everyone'], ['active', 'Asked in 7 days'], ['inactive', 'Stopped asking'],
  ['never', 'Never asked'], ['follow_up', 'Follow-up due'], ['unsubscribed', 'Unsubscribed'], ['suspended', 'Suspended'],
];

export const api = {
  get: (path, params) => axios.get(`${API}${path}`, { headers: authHeaders(), params }).then(({ data }) => data),
  put: (path, body) => axios.put(`${API}${path}`, body, { headers: authHeaders() }).then(({ data }) => data),
  post: (path, body) => axios.post(`${API}${path}`, body, { headers: authHeaders() }).then(({ data }) => data),
};

export const number = (value) => Number(value || 0).toLocaleString('en');
export const percent = (part, whole) => (whole ? `${Math.round((part / whole) * 100)}%` : '–');

const DAY = 86400000;
export const day = (iso) => (iso ? new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '–');

// "today", "3 days ago", "5 months ago"; null for never.
export function ago(iso, now = Date.now()) {
  if (!iso) return null;
  const days = Math.floor((now - new Date(iso).getTime()) / DAY);
  if (days <= 0) return 'today';
  if (days === 1) return 'yesterday';
  if (days < 60) return `${days} days ago`;
  if (days < 730) return `${Math.round(days / 30)} months ago`;
  return `${Math.round(days / 365)} years ago`;
}

// Accounts created from WhatsApp have no email: they are shown by name or phone number.
export function identity(user) {
  if (user.whatsapp_only) {
    return { title: user.name || user.whatsapp || 'WhatsApp user', subtitle: `WhatsApp account${user.name && user.whatsapp ? ` · ${user.whatsapp}` : ''}` };
  }
  return { title: user.name || user.email, subtitle: user.name ? user.email : '' };
}

export const errorText = (error) => error?.response?.data?.error || 'Something went wrong. Try again.';
